import { Maximize2, Minimize2 } from 'lucide-react';
import { usePageFocusMode } from '../contexts/PageFocusContext.tsx';
import { spinIconOut } from '../utils/iconAnimations.ts';

// Reusable floating "focus mode" toggle — hides the app's sidebar/topbar chrome and expands the
// current page to fill the viewport (see PageFocusContext.tsx + AppLayout.tsx). Any page can drop
// this in; it needs no props because it reads/writes the shared context itself. Dashboard.tsx is
// the first page to wire it up, but it isn't Dashboard-specific.

export default function PageFocusToggle({ style }: { style?: React.CSSProperties }) {
  const { focusMode, toggleFocusMode } = usePageFocusMode();

  return (
    <button
      type="button"
      className="combo-jello-spin"
      data-tint={focusMode ? 'blue' : 'neutral'}
      onClick={toggleFocusMode}
      onMouseEnter={(e) => { e.currentTarget.style.opacity = '1'; }}
      onMouseLeave={(e) => { e.currentTarget.style.opacity = focusMode ? '1' : '0.5'; spinIconOut(e); }}
      title={focusMode ? 'Exit focus mode' : 'Focus mode — hide navigation'}
      style={{
        width: 40, height: 40, borderRadius: '50%',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        border: focusMode ? '1px solid rgba(59,130,246,0.4)' : '1px solid var(--border-default)',
        background: focusMode ? 'rgba(59,130,246,0.16)' : 'var(--bg-elevated)',
        color: focusMode ? '#60a5fa' : 'var(--text-secondary)',
        cursor: 'pointer',
        boxShadow: 'var(--shadow-md)',
        opacity: focusMode ? 1 : 0.5,
        transition: 'opacity 0.15s ease',
        ...style,
      }}
    >
      {focusMode
        ? <Minimize2 size={17} className="btn-icon" />
        : <Maximize2 size={17} className="btn-icon" />}
    </button>
  );
}
